import React from "react"

const Shipping = () => {
  return (
    <div className="billing checkout-form__form">
      <div className="checkout-form-count">2</div>
      <h1 className="title-md">Shipping</h1>
      <div className="input-box">
        <label htmlFor="fullName">Shipping to:</label>
        <input type="text" name="fullName" id="fullName" />
      </div>
    </div>
  )
}

export default Shipping
